import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    view: 'card',
  },
  itemDesign: {},
  buttonDesign: {},
  containerDesign: {},

  activeItem: {},
};

export const couponSlice = createSlice({
  name: 'coupon',
  initialState,
  reducers: {
    couponStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, buttonDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      // state.itemDesign = {
      //   shape: itemDesign.shape ?? 'round',
      //   border: itemDesign.border ?? 'none',
      //   borderColor: itemDesign.borderColor ?? '#000000',
      //   shadow: itemDesign.shadow ?? 'none',
      //   shadowColor: itemDesign.shadowColor ?? '#000000',
      // };
      state.containerDesign = containerDesign ?? {};
      state.buttonDesign = buttonDesign ?? {};
      state.itemDesign = itemDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          ...blockContent.heading,
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };
      state.blockDesign = {
        view: blockDesign.view ?? 'card',
      };
    },
    couponClear: () => initialState,

    couponUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    couponUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    couponUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    couponUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },

    couponUpdateActiveItem: (state, action) => {
      state.activeItem = action.payload;
    },
    couponSetItems: (state, action) => {
      state.blockContent.items = action.payload ?? [];
    },
  },
});

export const { couponStore, couponClear, couponUpdateIsLoading, couponUpdateIsActive, couponUpdateBlockContent, couponUpdateBlockDesign, couponUpdateActiveItem, couponSetItems } =
  couponSlice.actions;

export const selectCouponIsLoading = (state) => state.coupon.isLoading;

export const selectCouponId = (state) => state.coupon.id;
export const selectCouponUID = (state) => state.coupon.uid;
export const selectCouponSID = (state) => state.coupon.sid;

export const selectCouponBlockContent = (state) => state.coupon.blockContent;
export const selectCouponBlockDesign = (state) => state.coupon.blockDesign;
export const selectCouponSortItems = createSelector([selectCouponBlockContent], ({ items }) => {
  return sortItems(items);
});
export const selectCouponItemDesign = (state) => state.coupon.itemDesign;
export const selectCouponButtonDesign = (state) => state.coupon.buttonDesign;
export const selectCouponContainerDesign = (state) => state.coupon.containerDesign;

export const selectCouponActiveItem = (state) => state.coupon.activeItem;

export default couponSlice.reducer;
